import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as NewLogo } from '../img/cabos-logo.svg'; // Import the SVG as a React component
import SetcastLogo from '../img/logo-setcast.png'

const Login = ({ setAuthenticated }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || '/'; // Default to dashboard if no prior location

    const handleSubmit = (e) => {
        e.preventDefault();

        // Simple hardcoded authentication
        if (username === 'mondula' && password === 'cabos-password!') {
            localStorage.setItem('authenticated', 'true');
            setAuthenticated(true);
            navigate(from); // Redirect to the page the user tried to access
        } else {
            alert('Invalid credentials');
        }
    };

    return (
        <div className='loginForm'>
            <form onSubmit={handleSubmit}>
                <div className='loginForm-container'>
                    <NewLogo className='App-logo' /> {/* Using inline SVG */}
                    <label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder='email'
                            required
                        />
                    </label>
                    <label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder='password'
                        />
                    </label>
                    <p className='password-reset-link'>Forgot your password?</p>
                    <button type="submit" className='big-button'>Login</button>
                </div>
            </form>
            <img src={SetcastLogo} alt='Setcast Logo'/>
        </div>
    );
};

export default Login;
